import { MedicalRecordForm } from 'models/MedicalRecord'
import React, { ReactNode, createContext, useState } from 'react'

import { medicalRecordFormatData } from '../formatter'
import { MedicalRecordFormData as FormSchemaProps } from '../medicalRecordSchema'

import MedicalRecordsService from 'services/medicalRecords'

interface OnUpdateDraftProps {
  formData: FormSchemaProps,
}

export interface MedicalRecordFormData {
  form: MedicalRecordForm
  isSavingDraft: boolean
  isErrorSavingDraft: boolean
  setForm: (form: MedicalRecordForm) => void
  onUpdateDraft: (draftProps: OnUpdateDraftProps) => Promise<void>
}

export const MedicalRecordFormContext = createContext<MedicalRecordFormData>(
  {} as MedicalRecordFormData
)

interface MedicalRecordFormProviderProps {
  children: ReactNode
}

export function MedicalRecordFormProvider({ children }: MedicalRecordFormProviderProps): JSX.Element {
  const [form, setForm] = useState<MedicalRecordForm>({} as MedicalRecordForm)
  const [isSavingDraft, setIsSavingDraft] = useState(false)
  const [isErrorSavingDraft, setIsErrorSavingDraft] = useState(false)

  async function handleUpdateDraft({ formData }: OnUpdateDraftProps) {
    try {
      setIsSavingDraft(true)
      setIsErrorSavingDraft(false)

      const medicalRecordFormFormatted = medicalRecordFormatData(formData, form)
  
      await MedicalRecordsService.updateDraft({
        formUuid: form.uuid,
        payload: medicalRecordFormFormatted,
      })
    } catch (error) {
      setIsErrorSavingDraft(true) 
    } finally {
      setIsSavingDraft(false)
    }
  }

  return (
    <MedicalRecordFormContext.Provider
      value={{
        form,
        isSavingDraft,
        isErrorSavingDraft,
        setForm,
        onUpdateDraft: handleUpdateDraft,
      }}
    >
      {children}
    </MedicalRecordFormContext.Provider>
  )
}
